import { Stack, styled, Typography } from "@mui/material";

export const MissingContractContextErrorStepWrapper = styled(Stack)(({ theme }) =>
    theme.unstable_sx({
        pt: theme.spacing(2),
        gap: theme.spacing(2),
    }),
);

export const MissingContractContextErrorStepTitle = styled(Typography)(({ theme }) =>
    theme.unstable_sx({
        fontWeight: 700,
        color: theme.palette.text.primary,
    }),
);

export const MissingContractContextErrorStepText = styled(Typography)(({ theme }) =>
    theme.unstable_sx({
        color: theme.palette.text.secondary,
    }),
);
